export const accountLogIcons = {
  googleicon:`<svg width="23" height="23" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_268_69)">
<path d="M28.227 14.3225C28.227 13.3708 28.1499 12.414 27.9852 11.4777H14.78V16.8689H22.342C22.0282 18.6076 21.02 20.1458 19.5436 21.1232V24.6212H24.055C26.7043 22.1829 28.227 18.5819 28.227 14.3225Z" fill="#4285F4"/>
<path d="M14.78 28.001C18.5558 28.001 21.7401 26.7612 24.0602 24.6212L19.5487 21.1231C18.2935 21.9771 16.673 22.4606 14.7851 22.4606C11.1327 22.4606 8.0359 19.9965 6.92475 16.6837H2.26923V20.2898C4.64586 25.0173 9.48657 28.001 14.78 28.001Z" fill="#34A853"/>
<path d="M6.91963 16.6837C6.33319 14.9449 6.33319 13.0621 6.91963 11.3234V7.71729H2.26925C0.283581 11.6732 0.283581 16.3339 2.26925 20.2898L6.91963 16.6837Z" fill="#FBBC04"/>
<path d="M14.78 5.54127C16.7759 5.51041 18.705 6.26146 20.1505 7.64012L24.1476 3.64305C21.6166 1.26642 18.2575 -0.0402103 14.78 0.000943444C9.48657 0.000943444 4.64586 2.98459 2.26923 7.71728L6.9196 11.3234C8.02561 8.00536 11.1276 5.54127 14.78 5.54127Z" fill="#EA4335"/>
</g>
<defs>
<clipPath id="clip0_268_69">
<rect width="28" height="28" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>`,

}
